angular.module('shiftTraderApp')
  .controller('EmployeeProfileCtrl', function($scope, $q, $uibModal, $timeout, me, user, org, regexStrings, toastr, Users, UserPermissionsService, OverrideTokens, UserAvailabilityChangeRequests, AvailabilitySets, Memberships, UserCommunicationSubscriptions, Departments, TimeService, WorkPeriods, DaysOffUserStatsService, TourService, TYPE_CFA_PERSON_ID, TYPE_CFA_EMPLOYEE_NUMBER) {
    $scope.me = me
    $scope.user = user
    $scope.org = org
    $scope.regexStrings = regexStrings

    if ($scope.me.$isAdmin() && !lodash.has($scope.me.completed_tours, 'employee-profile-tour') && !(($scope.org.$isInSandboxMode() || $scope.org.$isInTrialMode()) && $scope.org.organization_config.demo_state !== 'done')) {
      $timeout(function () { TourService.startTour('employee-profile-tour') }, 2000)
    }

    $scope.$on('sa:employeeProfile:switchTab', function (evt, index) {
      $scope.state.activeTab = index
    })

    $scope.state = {
      activeTab: 0,
      q: {
        isBirthdaySet: function() { return !!$scope.user.birthday },
        canChangeName: function() { return $scope.state.derivedPermissions.canChangeName },
        canChangeEmail: function() { return $scope.state.derivedPermissions.canChangeEmail },
        canChangeBirthday: function() { return $scope.state.derivedPermissions.canChangeBirthday },
        canChangePhoneNumber: function() { return $scope.state.derivedPermissions.canChangePhoneNumber },
        canShowContactSharing: function () { return $scope.state.derivedPermissions.canShowContactSharing },
        canChangeContactSharing: function () { return $scope.state.derivedPermissions.canChangeContactSharing },
        canChangeMembershipStatus: function () { return $scope.state.derivedPermissions.canChangeMembershipStatus },
        canSendReactivation: function () { return $scope.state.derivedPermissions.canSendReactivation },
        canChangeMembershipPermissions: function () { return $scope.state.derivedPermissions.canChangeMembershipPermissions },
        canChangeAllowableFlags: function () { return $scope.state.derivedPermissions.canChangeAllowableFlags },
        canShowManageNotifications: function () { return $scope.state.derivedPermissions.canShowManageNotifications },
        hasDayOffOverride: function () { return !!$scope.settings.state.dayOffOverride },
        hasAvailabilityOverride: function () { return !!$scope.settings.state.availabilityOverride },
        canOverrideDaysOff: function () { return $scope.state.derivedPermissions.canOverrideDaysOff },
        canOverrideAvailability: function () { return $scope.state.derivedPermissions.canOverrideAvailability },
        canCreateDayOff: function () { return $scope.state.derivedPermissions.canCreateDayOff },
        canChangeTargetHours: function () { return $scope.state.derivedPermissions.canChangeTargetHours },
        canChangeExternalId: function () { return $scope.state.derivedPermissions.canChangeExternalId },
        canManageIntegrations: function () { return $scope.state.derivedPermissions.canManageIntegrations },
        canShowIntegrations: function () { return $scope.state.derivedPermissions.canShowIntegrations },
      },
      cfaIdentifiers: (function() {
        var cfaPersonIdExternalIdent = $scope.user.memberships[0].external_identifiers.find(function (ext) { return ext.type === TYPE_CFA_PERSON_ID })
        var cfaEmployeeNumExternalIdent = $scope.user.memberships[0].external_identifiers.find(function (ext) { return ext.type === TYPE_CFA_EMPLOYEE_NUMBER })
        return {
          // show: !!externalIdent,
          cfaPersonId: cfaPersonIdExternalIdent ? cfaPersonIdExternalIdent.value : undefined,
          cfaEmployeeNum: cfaEmployeeNumExternalIdent ? cfaEmployeeNumExternalIdent.value : undefined,
        }
      })()
    }

    var permissionsToLookUp = [
      'users.change_my_avatar',
      'users.change_avatar',
      'users.update_name',
      'users.update_email_address',
      'users.update_birthday',
      'users.update_my_phone_number',
      'users.update_phone_number',
      'users.resend_activation',
      'users.view_info_in_org',

      'user_org_configs.change_my_contact_sharing',
      'user_org_configs.change_allowable_flags',

      'users_positions.create',
      'users_positions.set_inactive',

      'user_pay_rates.view',
      'user_pay_rates.create',
      'user_pay_rates.set_ineffective',

      'permission_sets.view_all_in_org',

      'memberships.change_active_state',
      'memberships.change_role',
      'memberships.change_external_ids',
      'memberships.show_integrations',
      'memberships.manage_integrations',

      'availability_sets.view_target',
      'availability_sets.create',
      'availability_sets.create_for_self',
      'availability_sets.create_override',
      'availability_sets.change_target_hours',

      'communication_subscriptions.manage_for_self',
      'communication_subscriptions.view_for_self',
      'communication_subscriptions.manage',
      'communication_subscriptions.view_in_org',
      'trades.can_receive_trade_notif',
      'users.can_receive_daily_digest',

      'days_off.request_for_self',
      'days_off.request_for_other',
      'days_off.create_override'
    ]

    var promises = [
      UserAvailabilityChangeRequests.getAll({
        organization_id: $scope.org.id,
        user_id: $scope.user.id
      }),
      AvailabilitySets.getUserPendingAndInReviewSets($scope.user.id),
      UserPermissionsService.getCanDict(permissionsToLookUp, $scope.org.id)
    ]

    $q.all(promises)
      .then(function (results) {
        $scope.availabilityCampaigns = results[0]
        $scope.pendingAndReviewingSets = results[1]
        $scope.state.rawPermissions = results[2]

        processRawPermissions()

        // Tab viewing is dependent on the permissions
        setupTabs()
      })

    function processRawPermissions() {
      var myProf = $scope.me.id === $scope.user.id
      var rawPerm = $scope.state.rawPermissions

      $scope.state.derivedPermissions = {
        canChangeAvatar: (myProf && rawPerm['users.change_my_avatar'] || !myProf && rawPerm['users.change_avatar']),
        canChangeName: rawPerm['users.update_name'],
        canChangeEmail: rawPerm['users.update_email_address'],
        canChangeBirthday: rawPerm['users.update_birthday'],
        canChangePhoneNumber: ($scope.me.id === $scope.user.id) ? rawPerm['users.update_my_phone_number']: rawPerm['users.update_phone_number'],
        canLoadPayRatesTemplate: rawPerm['user_pay_rates.view'] && rawPerm['user_pay_rates.create'] && rawPerm['user_pay_rates.set_ineffective'],
        canLoadDaysOffTemplate: rawPerm['days_off.request_for_other'] && rawPerm['days_off.create_override'],
        canCreateAvailability: (myProf && rawPerm['availability_sets.create_for_self']) || (!myProf && rawPerm['availability_sets.create']),
        canViewAvailability: rawPerm['availability_sets.view_target'],
        canManagePositions: rawPerm['users_positions.create'] && rawPerm['users_positions.set_inactive'],
        canShowContactSharing: (myProf && rawPerm['user_org_configs.change_my_contact_sharing']) || (!myProf && rawPerm['users.view_info_in_org']),
        canChangeContactSharing: myProf && rawPerm['user_org_configs.change_my_contact_sharing'],
        canChangeMembershipStatus: !myProf && rawPerm['memberships.change_active_state'],
        canSendReactivation: rawPerm['users.resend_activation'],
        canChangeMembershipPermissions: rawPerm['memberships.change_role'] && rawPerm['permission_sets.view_all_in_org'],
        canChangeAllowableFlags: rawPerm['user_org_configs.change_allowable_flags'],
        canShowManageNotifications: (myProf && rawPerm['communication_subscriptions.manage_for_self'] && rawPerm['communication_subscriptions.view_for_self']) || (!myProf && rawPerm['communication_subscriptions.manage'] && rawPerm['communication_subscriptions.view_in_org']),
        canOverrideDaysOff: rawPerm['days_off.create_override'],
        canOverrideAvailability: rawPerm['availability_sets.create_override'],
        canCreateDayOff: (myProf && rawPerm['days_off.request_for_self']) || (!myProf && rawPerm['days_off.request_for_other']),
        canChangeTargetHours: rawPerm['availability_sets.change_target_hours'],
        canChangeExternalId: rawPerm['memberships.change_external_ids'],
        canShowIntegrations: rawPerm['memberships.show_integrations'],
        canManageIntegrations: rawPerm['memberships.manage_integrations'],
      }

      $scope.availability.state.isSuperUser = rawPerm['availability_sets.create_override']
    }

    function setupTabs() {
      $scope.tabs = [
        // { title: 'Dashboard', template: '' },
        // { title: 'Schedule', template: '' },
        { title: 'Dashboard',     template: 'views/employeeProfile/tabs/dashboardTab.html',  show: true },
        { title: 'Information',   template: 'views/employeeProfile/tabs/informationTab.html',  show: true },
        { title: 'Pay Rates',     template: 'views/employeeProfile/tabs/payRatesTab.html',     show: $scope.state.derivedPermissions.canLoadPayRatesTemplate },
        { title: 'Positions',     template: 'views/employeeProfile/tabs/positionsTab.html', show: true },
        { title: 'Days Off',      template: 'views/employeeProfile/tabs/daysOffTab.html',  show: $scope.state.derivedPermissions.canLoadDaysOffTemplate },
        { title: 'Availability',  template: 'views/employeeProfile/tabs/availabilityTab.html', show: true },
        { title: 'Notes',         template: 'views/employeeProfile/tabs/notesTab.html', show: true },
        { title: 'Settings',      template: 'views/employeeProfile/tabs/settingsTab.html', show: true }
      ]

      $scope.dashboard.initTab()
      $scope.information.initTab()
      $scope.availability.initTab()

      if ($scope.state.derivedPermissions.canLoadDaysOffTemplate) {
        $scope.daysoff.initTab()
      }

      $scope.settings.initTab()

      $scope.notesLayout = {
        name: 'layout-employee-profile',
        data: {
          userId: $scope.user.id
        }
      }
    }

    $scope.dashboard = {
      initTab: function () {

        var startOfWeekSetting = $scope.org.organization_config.work_week_start

        $scope.today = TimeService.getNowInStoreTime()

        var lowerBound = $scope.today
        if ($scope.today.day() <= startOfWeekSetting) {
          upperBound = $scope.today.clone().add(startOfWeekSetting - $scope.today.day() - 1, 'days').endOf('day')
        } else {
          var daysTillEndWeek = 7 - ($scope.today.day() - startOfWeekSetting)
          upperBound = $scope.today.clone().add(daysTillEndWeek - 1, 'days').endOf('day')
        }

        $scope.dashboard.state.thisWeekDates = {
          lowerBound: lowerBound,
          upperBound: upperBound
        }

        WorkPeriods.getAll({
          start_time: lowerBound,
          end_time: upperBound,
          user_id: $scope.user.id
        }).then(function (workPeriods) {
            $scope.dashboard.state.thisWeekShifts = lodash.sortBy(lodash.filter(workPeriods, function (wp) {
              return wp.$isPublished()
            }), function (wp) {
              return wp.start_time.unix()
            })
          })

        lowerBound = upperBound.clone().add(6, 'hours').startOf('day')
        upperBound = lowerBound.clone().add(6, 'days').endOf('day')

        $scope.dashboard.state.nextWeekDates = {
          lowerBound: lowerBound,
          upperBound: upperBound
        }

        $scope.dashboard.state.workWeekStart = lowerBound.format('dddd')

        WorkPeriods.getAll({
          start_time: lowerBound,
          end_time: upperBound,
          user_id: $scope.user.id
        }).then(function (workPeriods) {
            $scope.dashboard.state.nextWeekShifts = lodash.sortBy(lodash.filter(workPeriods, function (wp) {
              return wp.$isPublished()
            }), function (wp) {
              return wp.start_time.unix()
            })
          })

        $scope.dashboard.state.pendingDaysOff = lodash.filter($scope.user.time_off_rules, function (request) { return request.$isPending() })
        $scope.dashboard.state.notPendingDaysOff = lodash.filter($scope.user.time_off_rules, function (request) { return !request.$isPending() })
      },
      state: {
        thisWeekShifts: null,
        nextweekShifts: null,
        workWeekStart: null
      },
      containers: {
        shifts: {
          editing: false,
          canEdit: function () { return false }
        },
        daysoff: {
          editing: false,
          canEdit: function () { return false }
        }
      },
      openRequestDayOffModal: function() {
        var modalInstance = $uibModal.open({
          size: 'request-day-off',
          templateUrl: 'views/daysOff/requestDayOffModal.html',
          controller: 'RequestDayOffModalCtrl',
          resolve: {
            params: function() {
              return { me: $scope.me, user: $scope.user }
            }
          }
        })
        modalInstance.result.then(function(resultsArray) {
          Users.getById($scope.user.id)
            .then(function (usr) {
              $scope.user = usr
              $scope.daysoff.initTab()

              $scope.dashboard.state.pendingDaysOff = lodash.filter($scope.user.time_off_rules, function (request) { return request.$isPending() })
              $scope.dashboard.state.notPendingDaysOff = lodash.filter($scope.user.time_off_rules, function (request) { return !request.$isPending() })
            })
        })
      }
    }

    $scope.information = {
      initTab: function () {
        $scope.user._phone_numbers = sortPhoneNumbers()
      },
      containers: {
        general: {
          editing: false,
          updateFields: {
            firstName: $scope.user.first_name,
            lastName: $scope.user.last_name,
            birthday: ($scope.user.birthday) ? moment($scope.user.birthday) : null
          },
          update: function() {
            var fields = $scope.information.containers.general.updateFields

            var payload = {}
            if (fields.firstName !== $scope.user.first_name) {
              payload.first_name = fields.firstName
            }
            if (fields.lastName !== $scope.user.last_name) {
              payload.last_name = fields.lastName
            }
            if (fields.birthday && !moment(fields.birthday).isSame($scope.user.birthday, 'day')) {
              payload.birthday = fields.birthday._d
            }

            if (!lodash.isEmpty(payload)) {
              user.$update(payload)
                .then(function(usr) {
                  $scope.user = usr
                  $scope.user._phone_numbers = sortPhoneNumbers()
                })
            }
          },
          canEdit: function() {
            return $scope.state.q.canChangeName() || $scope.state.q.canChangeBirthday()
          }
        },
        contact: {
          editing: false,
          updateFields: {
            email: ($scope.user.primary_email_address) ? $scope.user.primary_email_address.email: null,
            phoneNumber: null
          },
          update: function () {
            var fields = $scope.information.containers.contact.updateFields

            var payload = {}
            var promises = []
            if (fields.email && (!$scope.user.primary_email_address || fields.email !== $scope.user.primary_email_address.email)) {
              payload.email = fields.email
            }
            if (fields.phoneNumber) {
              promises = lodash.concat(promises, $scope.user.$addPhoneNumber({
                phone_number: {
                  number: fields.phoneNumber,
                  user_id: $scope.user.id
                },
                organization_id: $scope.org.id
              }).then(function (phoneNumber) {
                $scope.user._phone_numbers = sortPhoneNumbers()
                $scope.information.containers.contact.updateFields = null
              }))
            }

            if (!lodash.isEmpty(payload)) {
              promises.concat(promises, user.$update(payload))
            }
          },
          canEdit: function () {
            return $scope.state.q.canChangeEmail() || $scope.state.q.canChangePhoneNumber()
          }
        }
      }
    }

    $scope.availability = {
      state: {
        isSuperUser: null,
        noAvailability: null,
        currentSet: null,
        futureSet: null,
        inReviewSet: null,
        rightContainerState: 'future'
      },
      containers: {
        targetHours: {
          editing: false,
          updateFields: {
            targetHours: null
          },
          update: function () {
            var fields = $scope.availability.containers.targetHours.updateFields

            if (fields.targetHours !== $scope.availability.state.currentSet.target_hours) {
              $scope.availability.state.currentSet.$update({ target_hours: fields.targetHours, state: 2 })
                .then(function (availSet) {
                  $scope.availability.state.currentSet = availSet
                })
            }
          },
          canEdit: function () {
            return $scope.state.q.canChangeTargetHours()
          }
        }
      },
      toggleRightContainer: function() {
        if ($scope.availability.state.rightContainerState === 'future') {
          $scope.availability.state.rightContainerState = 'in-review'
        } else {
          $scope.availability.state.rightContainerState = 'future'
        }
      },
      initTab: function() {
        $scope.activeChangeRequest = _.find($scope.availabilityCampaigns, function(uacr) {
          return !uacr.$isExpired()
        })

        $scope.state.hasChangeRequest = !!$scope.activeChangeRequest

        $scope.state.hasSetPendingForChangeRequest = $scope.state.hasChangeRequest && $scope.activeChangeRequest.$hasPendingAvailabilitySet()
        $scope.state.hasSetInReviewForChangeRequest = $scope.state.hasChangeRequest && $scope.activeChangeRequest.$hasInReviewAvailabilitySet()
        $scope.state.hasSetApprovedForChangeRequest = $scope.state.hasChangeRequest && $scope.activeChangeRequest.$hasApprovedAvailabilitySet()

        $scope.state.needToRespondToChangeRequest = $scope.state.hasChangeRequest && !$scope.state.hasSetInReviewForChangeRequest && !$scope.state.hasSetApprovedForChangeRequest
        $scope.state.hasSetInReviewAfterApproval = $scope.state.hasChangeRequest && $scope.state.hasSetApprovedForChangeRequest && $scope.state.hasSetInReviewForChangeRequest
        $scope.state.hasSetPendingAfterApproval = $scope.state.hasChangeRequest && $scope.state.hasSetApprovedForChangeRequest && $scope.state.hasSetPendingForChangeRequest


        var isSuperUser = $scope.availability.state.isSuperUser
        var needToken = !$scope.org.organization_config.can_change_availability && !($scope.availabilityCampaigns && $scope.availabilityCampaigns.length > 0)
        $scope.availability.state.needToken = needToken

        $scope.availability.state.currentSet = _.find($scope.user.availability_sets, function(availSet) {
          return availSet.$isApproved() && availSet.$isInEffect() && availSet.active
        })
        $scope.availability.containers.targetHours.updateFields.targetHours = ($scope.availability.state.currentSet) ? $scope.availability.state.currentSet.target_hours : null

        $scope.availability.state.futureSet = _.find($scope.user.availability_sets, function(availSet) {
          return availSet.$isApproved() && !availSet.$isInEffect() && availSet.active
        })

        $scope.availability.state.inReviewSet = _.find($scope.pendingAndReviewingSets, function(availSet) {
          return availSet.$isInReview() && availSet.active
        })

        if ($scope.availability.state.inReviewSet) {
          $scope.availability.state.rightContainerState = 'in-review'
        } else {
          $scope.availability.state.rightContainerState = 'future'
        }
        $scope.availability.state.noAvailability = !$scope.availability.state.currentSet && !$scope.availability.state.futureSet && !$scope.availability.state.inReviewSet

        function setTopBarStatus () {
          $scope.availability.state.topBarStatus = {
            showBar: false,
            showStates: {
              requestFromManagement: $scope.state.needToRespondToChangeRequest && !$scope.state.hasSetPendingForChangeRequest,
              isEditing: $scope.state.needToRespondToChangeRequest && $scope.state.hasSetPendingForChangeRequest,
              setInReview: $scope.state.hasSetInReviewForChangeRequest && !$scope.state.hasSetApprovedForChangeRequest,
              setApproved: $scope.state.hasSetApprovedForChangeRequest && !$scope.state.hasSetInReviewAfterApproval && !$scope.pendingSet,
              setApprovedReview: $scope.state.hasSetInReviewAfterApproval,
              setApprovedPending: $scope.state.hasSetPendingAfterApproval,
            }
          }
          $scope.availability.state.topBarStatus.showStates.changeSet = ($scope.availability.state.futureSet || $scope.availability.state.inReviewSet) && lodash.every(lodash.values($scope.availability.state.topBarStatus.showStates), function (e) { return e === false }) && $scope.availability.state.canChangeAvailability
          $scope.availability.state.topBarStatus.showBar = lodash.some(lodash.values($scope.availability.state.topBarStatus.showStates), function (e) { return e === true })
        }

        if (isSuperUser || !needToken) {
          $scope.availability.state.canChangeAvailability = true
          setTopBarStatus()
        } else if (needToken) {

          OverrideTokens.getOne({
            user_id: $scope.user.id,
            organization_id: $scope.org.id,
            token_type: 'Availability'
          }).then(function(token) {
            console.log('Token', {
              user_id: $scope.user.id,
              organization_id: $scope.org.id,
              token_type: 'Availability'
            }, token)
            $scope.availability.state.overrideToken = token
            $scope.availability.state.canChangeAvailability = !!token

            setTopBarStatus()
          }, function(response) {
            console.log('Failed to load override token', response)
          })

        }
      }
    }

    $scope.daysoff = {
      initTab: function () {
        $scope.daysoff.state.availabilityStartDate = moment.utc().startOf('day').subtract(6, 'months').startOf('month')
        $scope.daysoff.state.daysOffStats = DaysOffUserStatsService.initializeInstance()
        $scope.daysoff.state.daysOffStats.init($scope.user, $scope.daysoff.state.availabilityStartDate, $scope.daysoff.setCurrentDaysoffList, true)
        $scope.$watch('daysoff.state.daysOffViewState', function() {
          $scope.daysoff.setCurrentDaysoffList()
        })
      },
      state: {
        availabilityStartDate: null,
        daysOffStats: null,
        daysOffViewState: 'pending',
        currentDaysoffList: null
      },
      setCurrentDaysoffList: function() {
        if ($scope.daysoff.state.daysOffViewState === 'pending') {
          $scope.daysoff.state.currentDaysoffList = $scope.daysoff.state.daysOffStats.data.pending.items
        } else if ($scope.daysoff.state.daysOffViewState === 'approved') {
          $scope.daysoff.state.currentDaysoffList = $scope.daysoff.state.daysOffStats.data.approved.items
        } else if ($scope.daysoff.state.daysOffViewState === 'disapproved') {
          $scope.daysoff.state.currentDaysoffList = $scope.daysoff.state.daysOffStats.data.disapproved.items
        } else if ($scope.daysoff.state.daysOffViewState === 'expired') {
          $scope.daysoff.state.currentDaysoffList = $scope.daysoff.state.daysOffStats.data.expired.items
        } else if ($scope.daysoff.state.daysOffViewState === 'cancelled') {
          $scope.daysoff.state.currentDaysoffList = $scope.daysoff.state.daysOffStats.data.cancelled.items
        } else if ($scope.daysoff.state.daysOffViewState === 'removed') {
          $scope.daysoff.state.currentDaysoffList = $scope.daysoff.state.daysOffStats.data.removed.items
        }

        $scope.daysoff.state.currentDaysoffList = _.map($scope.daysoff.state.currentDaysoffList, function(x) {
          x._mif = TimeService.minimalIntervalTimeFormat(x.range_twix)
          return x
        })

      }
    }

    $scope.settings = {
      initTab: function () {
        if ($scope.user.memberships[0].active && $scope.user.activated_at) {
          $scope.settings.state.activeState = 'active'
        } else if (!$scope.user.memberships[0].active) {
          $scope.settings.state.activeState = 'inactive'
        } else {
          $scope.settings.state.activeState = 'pending'
        }

        $scope.settings.getCurrentRoleOrSetName()
        $scope.settings.loadOverrideTokens()
      },
      state: {
        activeState: null
      },
      containers: {
        external: {
          editing: false,
          updateFields: {
            externalId: $scope.user.memberships[0].external_id,
            cfaPersonId: $scope.state.cfaIdentifiers.cfaPersonId,
            cfaEmployeeNum: $scope.state.cfaIdentifiers.cfaEmployeeNum,
          },
          update: function () {
            var fields = $scope.settings.containers.external.updateFields
            var payload = {
              id: $scope.user.memberships[0].id,
              membership: {},
            }

            if (fields.externalId !== $scope.user.memberships[0].external_id) {
              payload.membership.external_id = fields.externalId
            }

            if (fields.cfaPersonId !== $scope.state.cfaIdentifiers.cfaPersonId) {
              if (!payload.membership.integrations) {
                payload.membership.integrations = { cfa_integration: { identifiers: {} } }
              }
              payload.membership.integrations.cfa_integration.identifiers.cfa_person_id = fields.cfaPersonId
            }

            if (fields.cfaEmployeeNum !== $scope.state.cfaIdentifiers.cfaEmployeeNum) {
              if (!payload.membership.integrations) {
                payload.membership.integrations = { cfa_integration: { identifiers: {} } }
              }
              payload.membership.integrations.cfa_integration.identifiers.cfa_employee_number = fields.cfaEmployeeNum
            }

            if (Object.keys(payload.membership).length < 1) return

            Memberships.update(payload)
              .then(function (memb) {
                console.log('UPDATED', memb)
                $scope.user.memberships[0] = memb

                var cfaPersonIdent = $scope.user.memberships[0].external_identifiers.find(function (ext) { return ext.type === TYPE_CFA_PERSON_ID })
                if (cfaPersonIdent) {
                  $scope.state.cfaIdentifiers.cfaPersonId = cfaPersonIdent.value
                }

                var cfaEmployeeIdent = $scope.user.memberships[0].external_identifiers.find(function (ext) { return ext.type === TYPE_CFA_EMPLOYEE_NUMBER })
                if (cfaEmployeeIdent) {
                  $scope.state.cfaIdentifiers.cfaEmployeeNum = cfaEmployeeIdent.value
                }
              })
          },
          canEdit: function () {
            return $scope.state.q.canChangeExternalId()
          }
        }
      },
      loadOverrideTokens: function () {
        OverrideTokens.getOne({
          user_id: $scope.user.id,
          token_type: 'DayOff'
        }).then(function(token) {
          $scope.settings.state.dayOffOverride = token
        }, function(response) {
          console.log('Failed to fetch days off tokens', response)
          $scope.dayOffOverride = null
        })

        OverrideTokens.getOne({
          user_id: $scope.user.id,
          token_type: 'Availability'
        }).then(function(token) {
          $scope.settings.state.availabilityOverride = token
        }, function(response) {
          console.log('Failed to fetch days off tokens', response)
          $scope.availabilityOverride = null
        })
      },
      grantOverride: function (type) {
        if (type !== 'DayOff' && type !== 'Availability') {
          console.error('Invalid type of override requested')
          return
        }

        OverrideTokens.create({
          token_type: type,
          user_id: $scope.user.id
        }).then(function(token) {
          if (token.token_type == 'DayOff') {
            $scope.settings.state.dayOffOverride = token
          } else if (token.token_type == 'Availability') {
            $scope.settings.state.availabilityOverride = token
          }
        }, function(response) {
          console.log('Failed to create override token for ' + type)
        })
      },
      revokeOverride: function (type) {
        var token
        if (type == 'DayOff') {
          token = $scope.settings.state.dayOffOverride
        } else if (type == 'Availability') {
          token = $scope.settings.state.availabilityOverride
        } else {
          console.error('Invalid type of override requested')
          return
        }

        OverrideTokens.revoke(token.id)
          .then(function(token) {
            $scope.settings.loadOverrideTokens()
          }, function(response) {
            console.log('Failed to revoke override token for ' + type)
          })
      },
      getCurrentRoleOrSetName: function () {
        if ($scope.me.id === $scope.user.id) {
          UserPermissionsService.getNameOfCurrentRole(org.id)
            .then(function(name) {
              $scope.state.currentRoleOrSetName = name
            })
        } else {
          var memb = _.find($scope.user.memberships, {organization_id: org.id})

          if (memb) {
            if (!_.isNull(memb.permission_set_id)) {
              PermissionSetsStore.getRecordForId(memb.permission_set_id, org.id)
                .then(function(record) {
                  $scope.state.currentRoleOrSetName = record.name
                })
            } else {
              $scope.state.currentRoleOrSetName = memb.role
            }
          }
        }
      },
      toggleMembershipStatus: function (memb) {
        var data = {
          id: memb.id,
          active: (memb.active) ? 0 : 1
        }

        return Memberships.update(data)
          .then(function (resp) {
            user.memberships[0].active = resp.active

            if ($scope.user.memberships[0].active && $scope.user.activated_at) {
              $scope.settings.state.activeState = 'active'
            } else if (!$scope.user.memberships[0].active) {
              $scope.settings.state.activeState = 'inactive'
            } else {
              $scope.settings.state.activeState = 'pending'
            }

            toastr.success('Employee status has been successfully updated.', 'Employee' + ((user.memberships[0].active) ? 'Activated' : 'Deactivated'))
          }, function () {
            toastr.error('Employee status was not able to be successfully updated.', 'Employee Status Not Changed')
          })
      },
      resendActivation: function () {
        $scope.user.$resendActivationEmail()
          .then(function () {
            toastr.success('Another activation email has been successfully sent to ' + user.name, 'Activation Email Sent')
          }, function () {
            toastr.error('Unable to resend activation email. Please try again later.', 'Failed to Send Activation Email')
          })
      },
      openChangePermissionModal: function () {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/changeMembershipPermissionModal.html',
          controller: 'ChangeMembershipPermissionModalCtrl',
          size: 'md',
          resolve: {
            params: function() {
              return {
                me: $scope.me,
                user: $scope.user,
                org: $scope.org
              }
            },
            orgPermissionSets: ['PermissionSetsStore', function(PermissionSetsStore) {
              return PermissionSetsStore.getRecordsForOrgId($scope.org.id)
            }]
          }
        })
        modalInstance.result.then(function(newMembership) {
            var idx = _.findIndex($scope.user.memberships, {id: newMembership.id})
            if (idx > -1) {
              $scope.user.memberships[idx] = newMembership
            }

            $scope.settings.getCurrentRoleOrSetName()
          })
      },
      openManageNotifications: function () {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/manageNotificationsModal.html',
          controller: 'ManageNotificationsCtrl',
          controllerAs: 'manageNotifications',
          size: 'wide',
          resolve: {
            params: function() {
              return {
                me: $scope.me,
                user: $scope.user,
                rawPermissions: $scope.state.rawPermissions
              }
            },
            subs: ['UserCommunicationSubscriptions', function(UserCommunicationSubscriptions) {
              return UserCommunicationSubscriptions.getByUserId($scope.user.id)
            }],
            allDepartments: ['Departments', function(Departments) {
              return Departments.getAll({organization_id: $scope.org.id})
            }]
          }
        })
      }
    }

    function sortPhoneNumbers() {
      return lodash.sortBy($scope.user.phone_numbers, function(pn) { return !pn.primary })
    }

    $scope.setPrimaryPhoneNumber = function(phoneId) {
      $scope.user.$setPrimaryPhoneNumber(phoneId)
        .then(function(newPrimary) {
          var oldPrimaryIdx = lodash.findIndex($scope.user.phone_numbers, { primary: true })
          var newPrimaryIdx = lodash.findIndex($scope.user.phone_numbers, { id: newPrimary.id })
          $scope.user.phone_numbers[oldPrimaryIdx].primary = false
          $scope.user.phone_numbers[newPrimaryIdx].primary = true

          $scope.user._phone_numbers = sortPhoneNumbers()
        })
    }

    $scope.deletePhoneNumber = function(phoneId) {
      $scope.user.$removePhoneNumber(phoneId)
        .then(function() {
          lodash.remove($scope.user.phone_numbers, function(pn) { return pn.id === phoneId })
          var sortedById = lodash.sortBy($scope.user.phone_numbers, 'id')

          $scope.user.phone_numbers[lodash.findIndex($scope.user.phone_numbers, lodash.last(sortedById))].primary = true
          $scope.user._phone_numbers = sortPhoneNumbers()
        })
    }

    $scope.canEdit = function(tab, container) {
      return $scope[tab].containers[container].canEdit()
    }

    $scope.processContainer = function(tab, container, forceOption) {
      var currentCont = $scope[tab].containers[container]

      if (forceOption === 'close' || ($scope[tab].containers[container].editing && forceOption !== 'open')) {
        $scope[tab].containers[container].update()
      }

      $scope[tab].containers[container].editing = !$scope[tab].containers[container].editing
    }
  })
